{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "name",
              "displayLabel": "Person Name",
              "placeHolder": "Enter Person Name",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Person Name is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "designation",
              "displayLabel": "Designation",
              "placeHolder": "Enter Designation",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "email",
              "displayLabel": "Email",
              "placeHolder": "Enter Email",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Email is required"
                }
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "mobileNumber1",
              "displayLabel": "Mobile",
              "placeHolder": "Enter Mobile",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Mobile is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "mobileNumber2",
              "displayLabel": "Alternate Mobile",
              "placeHolder": "Enter Alternate Mobile",
              "fieldInfo": {
                "dataType": "number"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "communicationPreference",
              "displayLabel": "Communication Preference",
              "placeHolder": "Select Communication Preference",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  {
                    "label": "Email",
                    "value": "EMAIL"
                  },
                  {
                    "label": "Mobile",
                    "value": "MOBILE"
                  }
                ]
              }
            }
          }
        ]
      }
    ]
}